// StorePageTwo.tsx
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { updateForm } from "../../../redux/storeFormSlice";
import { useNavigate, useParams } from "react-router-dom";
import SubmitButton from "../../../components/form/SubmitButton";
import BackButton from "../../../components/ui/BackButton";
import MainTitle from "../../../components/ui/MainTitle";
import { useTranslation } from "react-i18next";
import GoogleMapComponent from "../../../components/store/createStoreForms/GoogleMap";
import StorePageTwoForm from "../../../components/store/createStoreForms/StorePageTwoForm";
import { useCategories, useSubCategoriesByCategory } from "../../../hooks/store/categories";
import SubTitle from "../../../components/ui/SubTitle";

export interface Page2FormData {
  name: { languageCode: string; name: string }[];
  phone: string;
  lat: number | null;
  lng: number | null;
  subTypeId: number | null;
  type?: number | null;
  sectorId?:number|null
}

export default function StorePageTwo() {
  const { ownerId} = useParams<{ ownerId: string}>();
  const numericOwnerId = ownerId ? parseInt(ownerId) : 0;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const { name, phone, lat, lng, subTypeId, type} = useSelector((state: RootState) => state.storeForm);


  const { control, register, handleSubmit, setValue, watch, formState: { errors } } = useForm<Page2FormData>({
    defaultValues: {
      name: name.length ? name : [{ languageCode: 'en', name: '' }, { languageCode: 'ar', name: '' }],
      phone,
      lat,
      lng,
      subTypeId,
      type: type || null,
    }
  });

  const {data:categories} = useCategories();
  const {data:subCategories} = useSubCategoriesByCategory(watch('type'));

  const selectedCategory = watch("type");

  useEffect(()=>{
        setValue("subTypeId",null);
  },[watch('type'),setValue])

  const selectedSubTypeId = watch("subTypeId");




const [mapPosition, setMapPosition] = useState<{ lat: number; lng: number } | null>(null);

useEffect(() => {
  if (lat != null && lng != null) {
    // إذا عندنا قيمة من props
    setMapPosition({ lat, lng });
  } else if (navigator.geolocation) {
    // محاولة الحصول على موقع المستخدم
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setMapPosition({
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        });
      },
      (error) => {
        console.warn("Geolocation failed, using default location", error);
        setMapPosition({ lat: 31.5, lng: 34.47 }); // fallback
      }
    );
  } else {
    // fallback لو المتصفح لا يدعم geolocation
    setMapPosition({ lat: 31.5, lng: 34.47 });
  }
}, [lat, lng]);

  useEffect(() => {
    if (!name.length) return;
    name.forEach((_, idx) => setValue(`name.${idx}.name`, name[idx].name));
    setValue("phone", phone);
    setValue("subTypeId", subTypeId);
    setValue("type", type || null);
    setValue("lat", lat);
    setValue("lng", lng);
  }, [name, phone, subTypeId, lat, lng, setValue, type]);

  const onNext = (data: Page2FormData) => {
    if (!mapPosition?.lat || !mapPosition?.lng) { alert(t("select_location_first")); return; }
    if (!data.type) { alert(t("select_category_first")); return; }
    if (!data.subTypeId) { alert(t("select_subtype_first")); return; }

    dispatch(updateForm({ ...data, lat: mapPosition?.lat, lng: mapPosition?.lng }));
    navigate(numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page3`: "/owner/add-store/page3");
  };

  return (
    <div className="p-6 container h-[100vh] overflow-auto">
      <form onSubmit={handleSubmit(onNext)} className="flex flex-col gap-6 w-full">
        <MainTitle title={t("public_information")} />

        <div>
          <SubTitle title="select_location"/>
          <GoogleMapComponent
          lat={mapPosition? mapPosition.lat :null}
          lng={mapPosition? mapPosition.lng : null}
          onLocationChange={(lat, lng) => setMapPosition({ lat, lng })}
        />
        </div>

        <StorePageTwoForm
          register={register}
          errors={errors}
          control={control}
          selectedCategory={selectedCategory || null}
          onSelectCategory={(id) => {
            setValue("type", id, { shouldValidate: true });
            setValue("subTypeId", null, { shouldValidate: true });
          }}
          filteredSubTypes={subCategories||[]}
          selectedSubTypeId={selectedSubTypeId || null}
          onSelectSubType={(id) => setValue("subTypeId", id, { shouldValidate: true })}
          categories={categories||[]}
        />

        <div className="grid grid-cols-2 gap-4">
          <BackButton url={numericOwnerId?`/admin/owners/${numericOwnerId}/add-store/page1`: "/owner/add-store/page1"} height={64} />
          <SubmitButton height={64} label={"next"} />
        </div>
      </form>
    </div>
  );
}
